import React from "react";
import { Box, Image, ResponsiveContext, Text } from "grommet";
import maison from "../../../images/m1.png";
import appartment from "../../../images/appartment.png";
import calendar_day from "../../../images/calendar_day.png";
import calendar_year from "../../../images/calendar_year.png";
import CheckBoxCards from "../../elements/checkbox_card";
import ClickableCards from "../../elements/clickable_card";
import {
  BIEN_TYPE,
  LOCATION_DURATION,
  PRODUCT,
  RESIDENCE_TYPE,
} from "../../../services/types";
import SelectableCard from "../../elements/selectable_card";
import translate from "../../../i18n/translate";
import { isMH, isPhone } from "../../../services/utils";

const Presentation = ({ devis, onDevisChange, product }) => {
  return (
    <ResponsiveContext.Consumer>
      {(size) => (
        <Box width={"full"}>
          <Box
            align="center"
            justify="center"
            gap="small"
            pad={"small"}
            width={"full"}
          >
            <Box width={"large"} justify="center" align="center">
              <Text>
                {translate("introduction")
                  .split("<br/>")
                  .map((s) => (
                    <>
                      <span>{s}</span>
                      <br />
                    </>
                  ))}
              </Text>
            </Box>

            <CheckBoxCards
              cards={[
                {
                  photo: maison,
                  title: translate("maison"),
                  size: "small",
                  checked: devis.bienType === BIEN_TYPE.maison,
                  onChange: () => onDevisChange("bienType", BIEN_TYPE.maison),
                },
                {
                  photo: appartment,
                  title: translate("appartement"),
                  size: "small",
                  checked: devis.bienType === BIEN_TYPE.appartement,
                  onChange: () =>
                    onDevisChange("bienType", BIEN_TYPE.appartement),
                },
              ]}
            />
            {devis.bienType && isMH(product) && (
              <Box gap="small">
                <Box width={"large"}>
                  <Text>
                    {devis.bienType === BIEN_TYPE.maison
                      ? translate("usage_maison")
                      : translate("usage_appt")}{" "}
                    ?<br />
                  </Text>
                </Box>
                <ClickableCards
                  size={size}
                  cards={[
                    {
                      title: translate("principale"),
                      selected:
                        devis.residenceType === RESIDENCE_TYPE.principale,
                      onClick: () =>
                        onDevisChange(
                          "residenceType",
                          RESIDENCE_TYPE.principale
                        ),
                    },
                    {
                      title: translate("secondaire"),
                      selected:
                        devis.residenceType === RESIDENCE_TYPE.secondaire,
                      onClick: () =>
                        onDevisChange(
                          "residenceType",
                          RESIDENCE_TYPE.secondaire
                        ),
                    },
                  ]}
                />
              </Box>
            )}
            {devis.bienType && product === PRODUCT.PNO && (
              <Box gap="small" pad={"small"}>
                <Box width={"large"}>
                  <Text>
                    {translate("votre")}{" "}
                    {devis.bienType === BIEN_TYPE.maison
                      ? translate("maison")
                      : translate("appartement")}{" "}
                    {translate("est")}{" "}
                    {devis.bienType === BIEN_TYPE.appartement
                      ? " est loué :"
                      : " est louée : "}
                    <br />
                    <br />
                  </Text>
                </Box>
                <Box
                  direction={isPhone(size) ? "column" : "row"}
                  gap="medium"
                  justify="center"
                  align="center"
                  width={"large"}
                >
                  <SelectableCard
                    textComponent={
                      <Box direction="row" gap="small">
                        <Box width={"xsmall"}>
                          <Image src={calendar_year} />
                        </Box>

                        <Text>{translate("duration_year")}</Text>
                      </Box>
                    }
                    selected={devis.locationDuration === LOCATION_DURATION.long}
                    onClick={() =>
                      onDevisChange("locationDuration", LOCATION_DURATION.long)
                    }
                  />
                  <SelectableCard
                    textComponent={
                      <Box direction="row" gap="small">
                        <Box width={"xsmall"}>
                          <Image src={calendar_day} />
                        </Box>
                        <Text>{translate("duration_month")}</Text>
                      </Box>
                    }
                    selected={
                      devis.locationDuration === LOCATION_DURATION.short
                    }
                    onClick={() =>
                      onDevisChange("locationDuration", LOCATION_DURATION.short)
                    }
                  />
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      )}
    </ResponsiveContext.Consumer>
  );
};

export default Presentation;
